!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], e) : e((t = t || self).ReactGovernor = {}, t.React);
}(this, function (t, c) {
  "use strict";

  function n(t, e) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }

  function u(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, c = t[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          n || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  var f = function () {
    function a(t, e, r) {
      var n = this,
          o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : [];

      for (var i in function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, a), this.getState = function () {
        return n.__state;
      }, this.dispatch = e, this.actions = {}, this.middlewares = Array.isArray(o) ? o : [o], this.middlewares = this.middlewares.map(function (t) {
        return t(r, e);
      }), t) {
        if ("function" != typeof t[i]) throw new TypeError('action is invalid: expected "function"; for "'.concat(typeof t[i], '"'));
        this.createAction(t[i], i);
      }
    }

    return function (t, e, r) {
      e && n(t.prototype, e), r && n(t, r);
    }(a, [{
      key: "createAction",
      value: function value(o, i) {
        var a = this;

        this.actions[i] = function () {
          for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
            e[r] = arguments[r];
          }

          var n = o.apply(void 0, e.concat([a.getState]));
          n && n.then ? n.then(function (t) {
            a.dispatchFromActionReducer(t, i);
          }) : a.dispatchFromActionReducer(n, i);
        };
      }
    }, {
      key: "dispatchFromActionReducer",
      value: function value(t, e) {
        var r, n;
        if ("function" != typeof t) return n = new TypeError('action "'.concat(e, '" must return a reducer function; instead got "').concat(typeof t, '"')), void this.dispatch({
          error: n
        });
        r = t(this.state);
        var o = !0,
            i = !1,
            a = void 0;

        try {
          for (var c, u = this.middlewares[Symbol.iterator](); !(o = (c = u.next()).done); o = !0) {
            r = (0, c.value)(e, r);
          }
        } catch (t) {
          i = !0, a = t;
        } finally {
          try {
            o || null == u.return || u.return();
          } finally {
            if (i) throw a;
          }
        }

        this.__state = r, this.dispatch({
          newState: this.state
        });
      }
    }, {
      key: "state",
      get: function get() {
        return this.__state;
      }
    }]), a;
  }();

  function s(t, e) {
    if (e.error) throw e.error;
    return e.newState;
  }

  t.useGovernor = function (t, e, r) {
    if (!e || "object" != typeof e && "function" != typeof e) throw new TypeError('contract is invalid: expected "object"; got "'.concat(typeof e, '"'), e);
    var n = u(c.useReducer(s, t), 2),
        o = n[0],
        i = n[1],
        a = u(c.useState(new f(e, i, t, r)), 1)[0];
    return a.__state = o, [a.__state, a.actions];
  }, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});